'use client';

import { format, parseISO } from 'date-fns';
import { deAT, enGB } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

type Props = {
  dateString: string;
};

export const DateFormatter = ({ dateString }: Props) => {
  const { i18n } = useTranslation();
  const locale = i18n.language === 'en' ? enGB : deAT;
  const date = parseISO(dateString);

  return <time dateTime={dateString}>{format(date, 'PP', { locale })}</time>;
};
